module.exports = __webpack_public_path__ + "img/Content distribution-c.11b26e7.svg";